import { render } from "./StartMenu.vue?vue&type=template&id=030c80c4&scoped=true&bindings={}"
import script from "./StartMenu.vue?vue&type=script&lang=ts"
export * from "./StartMenu.vue?vue&type=script&lang=ts"

import "./StartMenu.vue?vue&type=style&index=0&id=030c80c4&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-030c80c4"

export default script